export default "__VITE_ASSET__DEwZuahs__"